import { useColors } from "../../../../hooks/colors/useColors";
import { useUser } from "../../../../hooks/react-query/useUser";
import { useRedirectAnonymous } from "../../../../hooks/auth/useRedirectAnonymous";
import { useAppointmentList } from "../../../../hooks/react-query/useAppointmentList";
import { Card, Loader, LoadingOverlay } from "@mantine/core";
import { Container } from "../../../../components/UI/container/Container";
import { AppointmentItem } from "../../../../components/pages/user/appointments/AppointmentItem";
import { MyH1 } from "../../../../components/UI/my-h1/MyH1";
import { IconCalendarEvent } from "@tabler/icons";
import { isMobile } from "react-device-detect";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { MyHead } from "../../../../components/pages/MyHead";
import { Fragment } from "react";
import { BackToProfile } from "../../../../components/pages/user/BackToProfile";
import { useProcessingStore } from "../../../../components/config/store/usProccessingStore";
import { Footer } from "../../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function UserAppointmentPage() {
  const { colors } = useColors();
  const redirect = useRedirectAnonymous();
  const { user } = useUser();
  const { pastAppointmentData, pastAppointmentsAreLoading } =
    useAppointmentList();
  const { t } = useTranslation("common");
  const { processing } = useProcessingStore((state) => state);

  return (
    <Fragment>
      <MyHead title={t("user.appHistory")} description={t("user.appHistory")} />
      <BackToProfile />
      <LoadingOverlay visible={processing} />
      <MyH1 centerText className="pt-8 text-4xl">
        {t("user.appHistory")}
      </MyH1>
      {user && (
        <Fragment>
          <Container noHeight>
            {(typeof pastAppointmentData === "undefined" ||
              pastAppointmentData.length === 0) &&
              !pastAppointmentsAreLoading && (
                <div className="flex flex-col items-center justify-center h-full">
                  <IconCalendarEvent
                    opacity={0.8}
                    stroke={1}
                    size={isMobile ? 360 : "30em"}
                    color={colors.primary}
                  />
                </div>
              )}
            {pastAppointmentsAreLoading && (
              <div className="flex flex-col items-center justify-center">
                <Loader />
              </div>
            )}
            {pastAppointmentData && pastAppointmentData.length > 0 && (
              <Fragment>
                {pastAppointmentData.map((appointmentDTO, index) => {
                  return (
                    <Card
                      radius="xl"
                      className="px-8 py-4 my-8"
                      key={appointmentDTO.appointment.id}
                      style={{ backgroundColor: colors.primary }}
                    >
                      <AppointmentItem
                        appointmentDTO={appointmentDTO}
                        past={true}
                      />
                    </Card>
                  );
                })}
              </Fragment>
            )}
          </Container>
        </Fragment>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default UserAppointmentPage;
